import React, { useEffect, useMemo, useState } from 'react';
import {
  MobileGameHolder,
  MobileGameStructure,
  MobileGameWr,
} from '@pascal/pascal-core/table-line/table-components';
import {
  DefaultQueryParams,
  GameControllers,
  iframeService,
  SidebarHolder,
  parseQuery,
  RightSideHolder,
  TableFooter,
  useTranslation,
  useUserCountStore,
  useUserInfoStore,
  MobileStructureMiddle,
  parseNumberByPrecision,
  OverlayFooter,
  tableBetHistoryStore,
  FreeBetsWrapper,
  useSoundWatcher,
} from '@pascal/pascal-core';
import { GameControllerTypes } from '@pascal/pascal-core/table-line/t_types/enums/GameControllerTypes';
import { observer } from 'mobx-react-lite';
import { TableMobileHeader } from '@pascal/pascal-core/table-line/table-containers/mobileHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import { GAME_CONTROLLER_TYPES } from '@pascal/pascal-core/shared/core/enums/gameControllerTypes';
import { applicationStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import gameLogo from '../assets/images/loading/game-logo-min.png';
import { HelpPopup } from '../components/helpPopup';
import { BetHistoryWr } from './betHistory';
import LimitAndPayouts from './payoutsAndResultsContainer/limitsAndPayouts';
import { doBetStore } from '../store/doBetStore';
import { winningAmountStore } from '../store/winningAmountStore';
import MobileResultContainer from './mobileResultContainer';
import { SettingsContainer } from './settingsContainer';
import AdditionalResultWr from './payoutsAndResultsContainer/additionResultWr';
import { TURBO_OR_TERMINAL_GAME_ID } from '../enums/constants';
import { GameCardHolderContainer } from './gameCardHolderContainer';
import { CardHolderWebView } from '../components/cardHolderView';
import { CountDown, DealerCards } from '../components';
import PlayerHands from './playerHands';
import ChipsWrapper from './chipsWrapper';
import ControlPanel from './controlPanel';
import WinPopup from '../components/winPopUp';
import { cardsStore } from '../store/cardsStore';
import { ShuffleCardsWrapper } from '../components/shuffleCardWraper';
import {
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
  AdditionalResponseCode,
} from '../enums/notificaions';
import { FreeChipRules } from '../components/freeChipRules';

const gameControllerComponents = {
  [GameControllerTypes.Help]: <HelpPopup />,
  [GameControllerTypes.History]: <BetHistoryWr />,
  [GameControllerTypes.Settings]: <SettingsContainer />,
  [GameControllerTypes.Results]: <MobileResultContainer />,
  [GAME_CONTROLLER_TYPES.PAYOUTS_AND_LIMITS]: <LimitAndPayouts />,
};
const secondNumber = 1;

export const MobileGame = observer(() => {
  const t = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { [DefaultQueryParams.UserId]: userId } = parseQuery(search);
  const [gameControllerType, setGameControllerType] = useState('');
  const { selectedHistoryRow, setSelectedHistoryRow } = tableBetHistoryStore;
  const { usersCount } = useUserCountStore();
  const { currencyCode } = useUserInfoStore();
  const { betsTotalAmount } = doBetStore;
  const { isShuffle } = cardsStore;
  const { lastWinAmount, winningAmount } = winningAmountStore;
  const { isTestPlatform } = applicationStore;
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const isTurbo = +gameId === TURBO_OR_TERMINAL_GAME_ID;

  useSoundWatcher();

  const GameControllerComponent = useMemo(() => {
    const component = gameControllerComponents[gameControllerType];
    if (component) {
      return component;
    }
    return null;
  }, [gameControllerType]);

  const navigationItems = useMemo(() => {
    const items = [
      {
        icon: 'icon-home1',
        name: t('HOME'),
        onClick: () => iframeService.exitGame(),
      },
      {
        icon: 'icon-lobby',
        name: t('LOBBY'),
        onClick: () => navigate(`/${search}`),
      },
      {
        icon: 'icon-limits',
        name: t('LIMITS_AND_PAYOUTS'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.PAYOUTS_AND_LIMITS),
        isPayTable: true,
      },
      {
        icon: 'icon-history',
        name: t('HISTORY'),
        isDisabled: !userId,
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.HISTORY),
      },
      {
        icon: 'icon-settings',
        name: t('SETTINGS'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.SETTINGS),
      },
      {
        icon: 'icon-help',
        name: t('RULES'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.HELP),
      },
    ];
    if (isTurbo) {
      items.splice(1, 1);
      return items;
    }
    if (isTestPlatform) {
      items.splice(3, 1);
      return items;
    }
    return items;
  }, [isTestPlatform, isTurbo, navigate, search, t, userId]);

  useEffect(() => {
    if (!isTurbo) {
      const el = document.createElement('span');
      const parent = document.querySelector('.m-user-count-holder');
      el.classList.add('m-user-count-txt');
      el.innerText = usersCount || '';
      parent.prepend(el);
    }
  }, [usersCount, isTurbo]);

  return (
    <MobileGameWr>
      <MobileGameStructure>
        <TableMobileHeader isShowGameTypes={false} logoSrc={gameLogo} />
        <MobileStructureMiddle
          haveNotification
          translationValues={{}}
          AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
          AdditionalResponseCode={AdditionalResponseCode}
          AdditionalErrorMessages={AdditionalErrorMessages}
        >
          <MobileGameHolder>
            <div className='turbo-blackjack-mobile-wrapper'>
              <FreeBetsWrapper
                additionalSliderComponents={{
                  index: 1,
                  component: <FreeChipRules />,
                }}
              />
              <div className='tb-game-board'>
                <div className='tb-card-holder'>
                  {!isShuffle ? <GameCardHolderContainer innerComp={CardHolderWebView} /> : null}
                  {/* ToDo: Add class "start-anim" to start the animation */}
                  {/* <CardAnimation /> */}
                  {isShuffle ? <ShuffleCardsWrapper /> : null}
                </div>
                <CountDown isShuffle={isShuffle} />
                {!isShuffle ? (
                  <>
                    <ChipsWrapper />

                    <PlayerHands />

                    <DealerCards />

                    <ControlPanel />
                  </>
                ) : null}
                {winningAmount ? (
                  <WinPopup winningAmount={winningAmount} t={t} currencyCode={currencyCode} />
                ) : null}
              </div>
            </div>
          </MobileGameHolder>
          <SidebarHolder setGameControllerType={setGameControllerType} hasSideIcon>
            <GameControllers
              currencyCode={currencyCode}
              controllerType={gameControllerType}
              setGameControllerType={() => setGameControllerType(null)}
              selectedHistoryRow={selectedHistoryRow}
              setSelectedHistoryRow={setSelectedHistoryRow}
              gameControllerComponent={GameControllerComponent}
              hasScrollToBottom={gameControllerType === GAME_CONTROLLER_TYPES.RESULTS}
              additionalContent={
                gameControllerType === GAME_CONTROLLER_TYPES.RESULTS ? (
                  <OverlayFooter title={t('LAST_CARDS')}>
                    <AdditionalResultWr />
                  </OverlayFooter>
                ) : null
              }
            />
          </SidebarHolder>
          <RightSideHolder navigationItems={navigationItems} />
        </MobileStructureMiddle>
        <TableFooter
          lastWin={lastWinAmount}
          totalBet={parseNumberByPrecision(betsTotalAmount, secondNumber, +userInfoStore.precision)}
          centerBlock={
            isTurbo ? null : (
              <>
                <div className='user-icon-b'>
                  <i className='icon-users' />
                </div>
                <div className='m-user-count-holder' />
              </>
            )
          }
        />
      </MobileGameStructure>
    </MobileGameWr>
  );
});
